import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import BootstrapVue from 'bootstrap-vue'
import vbclass from 'vue-body-class'
import Toasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import VueCryptojs from 'vue-cryptojs'
import VueFacebookPixel from 'vue-facebook-pixel'
import VueSocketIOExt from 'vue-socket.io-extended'
import { io } from 'socket.io-client'
import mixpanel from 'mixpanel-browser'
import { encrypt, decrypt } from './utils/functions'





if(process.env.VUE_APP_DISABLE_LOGS == 'true') {
    const fakeConsole = {}
    const noop = () => {}
    const methods = [
        'log',
        'debug',
        'info',
        'warn',
        'error',
        'trace',
        'group',
        'groupCollapsed',
        'groupEnd',
    ]
    methods.forEach((m) => (fakeConsole[m] = noop))
    window.console = fakeConsole
}

document.addEventListener('contextmenu', (event) => event.preventDefault())

// Disable F12
document.addEventListener('keydown', (event) => {
    if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && event.key === 'I')
    ) {
        event.preventDefault()
    }
})

console.log('SOCKET IN ENV FILE : ', process.env.VUE_APP_SOCKET_URL)
const socket = io(process.env.VUE_APP_SOCKET_URL)
mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN)

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import Tawk from 'vue-tawk'

import {
    VueAuthenticateConfig,
    VeeValidateConfig,
    ToastedConfig,
} from '@/config'

import IdleVue from 'idle-vue'
import helpers from './helpers'
const plugin = {
    install() {
        Vue.helpers = helpers
        Vue.prototype.$helpers = helpers
    },
}
Vue.use(plugin)
const eventsHub = new Vue()

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: process.env.VUE_APP_TIME_OUT, // 10 mints,
    startAtIdle: false,
})

Vue.use(VueFacebookPixel, { router })
Vue.use(VueCryptojs)

// Load the full build.
window._ = require('lodash')

Vue.use(VueCryptojs)
Vue.use(require('vue-moment'))
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, VueAuthenticateConfig)
Vue.use(VeeValidate, VeeValidateConfig)
Vue.use(Toasted, ToastedConfig)
Vue.use(BootstrapVue)
Vue.use(vbclass, router)
// Vue.use(Tawk, {
//     tawkSrc: 'https://embed.tawk.to/619cec7a6bb0760a4943f62a/1fl6fng42',
// })

Vue.config.productionTip = false
// Vue.config.devtools = true

Vue.use(VueCryptojs)
Vue.use(VueSocketIOExt, socket)

Vue.use(Antd)

require('@/auto-import.js')
require('@/route-middleware')
require('@/interceptor')
require('./filters')
require('./directives/authenticated-image')
Vue.prototype.$encrypt = encrypt
Vue.prototype.$decrypt = decrypt
window.httpRequest = Vue.prototype

new Vue({
    router: router,
    store,
    watch: {
        $route: function () {
            this.checkMeta()
            this.pageTop()
        },
    },
    methods: {
        checkMeta() {
            document.title =
                process.env.VUE_APP_TITLE + ' | ' + this.$route.meta.title
        },
        pageTop() {
            window.scrollTo(0, 0)
        },
    },
    render: (h) => h(App),
}).$mount('#app')
